module.exports = __webpack_public_path__ + "img/discount.bcd7395b.jpg";